import React, { useEffect, useState } from 'react';
import { getOfferLetterTemplate, postTimeline, sendMail, updateExpOfferDetails, updateOfferDetails } from '../service/RecruiterApi';
import { useNavigate } from 'react-router-dom';
import OfferLetterTemplate from './OfferLetterTemplate/OfferLetterTemplate';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { Upload } from './utils/Upload';
import { uploadBackend } from '../utils/Upload';
import Loader from '../StaticComponent/Loader';

function GenerateOfferletter(props) {
    const { salaryDetails, personalDetails, jobTitle, offerValid } = props;
    const [offerTemplates, setOfferTemplates] = useState([]);
    const [SelectedTemplate, setSelectedTemplate] = useState('');
    const [isloading, setisloading] = useState(true);
    const [offerletterDetails, setOfferLetterDetails] = useState({
        firstname: '',
        lastname: '',
        street: '',
        city: '',
        state: '',
        ctc: '',
        middlename: '',
        jobTitle: '',
        gender: '',
        monthlyBasic: '',
        annualBasic: '',
        monthlyHra: '',
        annualHra: '',
        monthlyTotalA: '',
        annualTotalA: '',
        monthlyMedicalAllowance: '',
        annualMedicalAllowance: '',
        monthlyLta: '',
        annualLta: '',
        monthlyConveyance: '',
        annualConveyance: '',
        monthlySpecialAllowance: '',
        annualSpecialAllowance: '',

        monthlyTotalB: '',
        annualTotalB: '',
        monthlyPf: '',
        annualPf : '',
        monthlyTotalC: '',
        annualTotalC: '',
        monthlyABCTotal: '',
        annualABCTotal: '',
        monthlyBenefits: '',
        annualBenefits: '',
        TotalTemp7: '',
        TotalTemp8: '',
        monthlyABCDTotal: '',
        annualABCDTotal: '',
        Signingdate: '',
        SalaryinWords: '',
        Month: '',
    });

    const navigate = useNavigate();
    let search = window.location.search;
    const candidate_id = new URLSearchParams(search).get('id');
    const experience = new URLSearchParams(search).get('exp');
    const jid = new URLSearchParams(search).get('jid');

    useEffect(() => {
        getOfferLetterTemplates();
    }, []);
    var a = [
        '',
        'one ',
        'two ',
        'three ',
        'four ',
        'five ',
        'six ',
        'seven ',
        'eight ',
        'nine ',
        'ten ',
        'eleven ',
        'twelve ',
        'thirteen ',
        'fourteen ',
        'fifteen ',
        'sixteen ',
        'seventeen ',
        'eighteen ',
        'nineteen ',
    ];
    var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

    function inWords(num) {
        let n;
        // if ((num = num.toString()).length > 9) return 'overflow';
        n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!n) return;
        var str = '';
        str += n[1] != 0 ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
        str += n[2] != 0 ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
        str += n[3] != 0 ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
        str += n[4] != 0 ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
        str += n[5] != 0 ? (str != '' ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'only ' : '';
        return str;
    }
    useEffect(() => {
        const date = new Date();

        const monthNames = ['Jan', 'Feb', 'March', 'April', 'May', 'Jun', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        const d = new Date();
        let val = '';

        if (salaryDetails.annualCtc) {
            
            let salary = inWords(salaryDetails?.annualCtc?.slice(0, -4));

            val = salary?.slice(0, -5);
        }

        let monthlyBasic,
        annualBasic,
        monthlyHra,
        annualHra,
        monthlyTotalA, 
        annualTotalA,
        monthlyMedicalAllowance,
        annualMedicalAllowance,
        monthlyLta,
        annualLta,
        monthlyConveyance,
        annualConveyance,
        monthlySpecialAllowance,
        annualSpecialAllowance ,
        monthlyTotalB,
        annualTotalB ,
        monthlyPf, 
        annualPf ,
        monthlyTotalC,
        annualTotalC,
        monthlyABCTotal,
        annualABCTotal,
        monthlyBenefits,
        annualBenefits,
            TotalTemp7,
            TotalTemp8,
            monthlyABCDTotal,
        annualABCDTotal,
            Signingdate,
            SalaryinWords,
            Month;

        let year = d.getFullYear();
        Month = monthNames[d.getMonth()];
        switch (true) {
            case salaryDetails?.annualCtc==='4.5 CTC' || salaryDetails?.annualCtc==='4.5 ctc' || salaryDetails?.annualCtc==='4.5 Ctc':
                monthlyBasic = 15000;
                    annualBasic = 180000;
                    monthlyHra = 7500;
                    annualHra = 90000;
                    monthlyTotalA = 22500;
                    annualTotalA = 270000;
                    monthlyMedicalAllowance = 1250;
                    annualMedicalAllowance = 15000;
                    monthlyLta = 1300 ;
                    annualLta = 15600 ;
                    monthlyConveyance = 1600;
                    annualConveyance = 19200;
                    monthlySpecialAllowance = 717;
                    annualSpecialAllowance = 8600;
                    monthlyTotalB = 4867;
                    annualTotalB = 58400;
                    monthlyPf = 1800;
                    annualPf = 21600;
                    monthlyTotalC = 1800;
                    annualTotalC = 21600;
                    monthlyABCTotal = 29167 ;
                    annualABCTotal =  350000;
                    monthlyBenefits = 8333;
                    annualBenefits = 100000;
                    TotalTemp7 = 8333;
                    TotalTemp8 = 100000;
                    monthlyABCDTotal = 37500;
                    annualABCDTotal = 450000;
                break;

            case salaryDetails?.annualCtc==='5 CTC' || salaryDetails?.annualCtc==='5 ctc' ||salaryDetails?.annualCtc=== '5 Ctc':
                monthlyBasic = 15000;
                    annualBasic = 180000;
                    monthlyHra = 7500;
                    annualHra = 90000;
                    monthlyTotalA = 22500;
                    annualTotalA = 270000;
                    monthlyMedicalAllowance = 1250;
                    annualMedicalAllowance = 15000;
                    monthlyLta = 1300;
                    annualLta = 15600;
                    monthlyConveyance = 1600;
                    annualConveyance = 19200;
                    monthlySpecialAllowance = 4883;
                    annualSpecialAllowance = 58600;
                    monthlyTotalB = 9033;
                    annualTotalB = 108400;
                    monthlyPf = 1800;
                    annualPf = 21600;
                    monthlyTotalC = 1800;
                    annualTotalC = 21600;
                    monthlyABCTotal = 33333;
                    annualABCTotal =  400000;
                    monthlyBenefits = 8333;
                    annualBenefits = 100000;
                    TotalTemp7 = 8333;
                    TotalTemp8 = 100000;
                    monthlyABCDTotal = 41666;
                    annualABCDTotal = 500000;

                break;
            case salaryDetails?.annualCtc==='5.5 CTC' ||salaryDetails?.annualCtc=== '5.5 ctc' || salaryDetails?.annualCtc==='5.5 Ctc':
                monthlyBasic = 15000;
                    annualBasic = 180000;
                    monthlyHra = 7500;
                    annualHra = 90000;
                    monthlyTotalA = 22500;
                    annualTotalA = 270000;
                    monthlyMedicalAllowance = 1250;
                    annualMedicalAllowance = 15000;
                    monthlyLta = 1300 ;
                    annualLta = 15600 ;
                    monthlyConveyance = 1600 ;
                    annualConveyance = 19200 ;
                    monthlySpecialAllowance = 9050 ;
                    annualSpecialAllowance = 108600 ;
                    monthlyTotalB = 13200 ;
                    annualTotalB = 158400 ;
                    monthlyPf = 1800 ;
                    annualPf = 21600 ;
                    monthlyTotalC = 1800 ;
                    annualTotalC = 21600;
                    monthlyABCTotal = 37500;
                    annualABCTotal =  450000 ;
                    monthlyBenefits = 8333;
                    annualBenefits = 100000;
                    TotalTemp7 = 8333;
                    TotalTemp8 = 100000;
                    monthlyABCDTotal = 45833;
                    annualABCDTotal = 550000;
                break;

            case salaryDetails?.annualCtc==='6 CTC' || salaryDetails?.annualCtc==='6 ctc' || salaryDetails?.annualCtc==='6 Ctc':
                monthlyBasic = 15500;
                    annualBasic = 186000;
                    monthlyHra = 6000;
                    annualHra = 72000;
                    monthlyTotalA = 21500;
                    annualTotalA = 258000;
                    monthlyMedicalAllowance = 1250;
                    annualMedicalAllowance = 15000;
                    monthlyLta = 1300 ;
                    annualLta = 15600 ;
                    monthlyConveyance = 1600;
                    annualConveyance = 19200;
                    monthlySpecialAllowance = 14217;
                    annualSpecialAllowance = 170600;
                    monthlyTotalB = 18367 ;
                    annualTotalB = 220400;
                    monthlyPf = 1800;
                    annualPf = 21600;
                    monthlyTotalC = 1800;
                    annualTotalC = 21600;
                    monthlyABCTotal = 41667 ;
                    annualABCTotal =  500000;
                    monthlyBenefits = 8333;
                    annualBenefits = 100000;
                    TotalTemp7 = 8333;
                    TotalTemp8 = 100000;
                    monthlyABCDTotal = 50000;
                    annualABCDTotal = 600000;
                break;

                case salaryDetails?.annualCtc==='6.5 CTC' ||salaryDetails?.annualCtc=== '6.5 ctc' ||salaryDetails?.annualCtc=== '6.5 Ctc':
                monthlyBasic = 15500;
                    annualBasic = 186000;
                    monthlyHra = 6000;
                    annualHra = 72000;
                    monthlyTotalA = 21500;
                    annualTotalA = 258000;
                    monthlyMedicalAllowance = 1250;
                    annualMedicalAllowance = 15000;
                    monthlyLta = 1300 ;
                    annualLta = 15600 ;
                    monthlyConveyance = 1600;
                    annualConveyance = 19200;
                    monthlySpecialAllowance = 18383;
                    annualSpecialAllowance = 220600;
                    monthlyTotalB = 22533;
                    annualTotalB = 270400;
                    monthlyPf = 1800;
                    annualPf = 21600;
                    monthlyTotalC = 1800;
                    annualTotalC = 21600;
                    monthlyABCTotal = 45833;
                    annualABCTotal =  550000 ;
                    monthlyBenefits = 8333;
                    annualBenefits = 100000;
                    TotalTemp7 = 8333;
                    TotalTemp8 = 100000;
                    monthlyABCDTotal = 54166;
                    annualABCDTotal = 650000;
                break;

                case salaryDetails?.annualCtc==='7 CTC' ||salaryDetails?.annualCtc=== '7 ctc' || salaryDetails?.annualCtc==='7 Ctc':
                    monthlyBasic = 15500;
                    annualBasic = 186000;
                    monthlyHra = 7000;
                    annualHra = 84000;
                    monthlyTotalA = 22500;
                    annualTotalA = 270000;
                    monthlyMedicalAllowance = 1250;
                    annualMedicalAllowance = 15000;
                    monthlyLta = 1600;
                    annualLta = 19200;
                    monthlyConveyance = 1600;
                    annualConveyance = 19200;
                    monthlySpecialAllowance = 21250;
                    annualSpecialAllowance = 255000;
                    monthlyTotalB = 25700;
                    annualTotalB = 308400;
                    monthlyPf = 1800;
                    annualPf = 21600;
                    monthlyTotalC = 1800;
                    annualTotalC = 21600;
                    monthlyABCTotal = 50000;
                    annualABCTotal =  600000;
                    monthlyBenefits = 8333;
                    annualBenefits = 100000;
                    TotalTemp7 = 8333;
                    TotalTemp8 = 100000;
                    monthlyABCDTotal = 58333;
                    annualABCDTotal = 700000;
                    break;

            case salaryDetails?.annualCtc==='7.5 CTC' || salaryDetails?.annualCtc==='7.5 ctc' ||salaryDetails?.annualCtc=== '7.5 Ctc':
                monthlyBasic = 15500;
                        annualBasic = 186000;
                        monthlyHra = 7000;
                        annualHra = 84000;
                        monthlyTotalA = 22500;
                        annualTotalA = 270000;
                        monthlyMedicalAllowance = 1250;
                        annualMedicalAllowance = 15000;
                        monthlyLta = 1600;
                        annualLta = 19200;
                        monthlyConveyance = 1600;
                        annualConveyance = 19200;
                        monthlySpecialAllowance = 25417;
                        annualSpecialAllowance = 305004;
                        monthlyTotalB = 29867;
                        annualTotalB = 358404;
                        monthlyPf = 1800;
                        annualPf = 21600;
                        monthlyTotalC = 1800;
                        annualTotalC = 21600;
                        monthlyABCTotal = 54167;
                        annualABCTotal =  650000;
                        monthlyBenefits = 8333;
                        annualBenefits = 100000;
                        TotalTemp7 = 8333;
                        TotalTemp8 = 100000;
                        monthlyABCDTotal = 62500;
                        annualABCDTotal = 750000;
                        break;

                case salaryDetails?.annualCtc==='8 CTC' || salaryDetails?.annualCtc==='8 ctc' ||salaryDetails?.annualCtc=== '8 Ctc':
                        monthlyBasic = 15500;
                        annualBasic = 186000;
                        monthlyHra = 7500;
                        annualHra = 90000;
                        monthlyTotalA = 23000;
                        annualTotalA = 276000;
                        monthlyMedicalAllowance = 1250;
                        annualMedicalAllowance = 15000;
                        monthlyLta = 1600;
                        annualLta = 19200;
                        monthlyConveyance = 1600;
                        annualConveyance = 19200;
                        monthlySpecialAllowance = 29083;
                        annualSpecialAllowance = 265000;
                        monthlyTotalB = 33533;
                        annualTotalB = 402400;
                        monthlyPf = 1800;
                        annualPf = 21600;
                        monthlyTotalC = 1800;
                        annualTotalC = 21600;
                        monthlyABCTotal = 58333;
                        annualABCTotal =  700000;
                        monthlyBenefits = 8333;
                        annualBenefits = 100000;
                        TotalTemp7 = 8333;
                        TotalTemp8 = 100000;
                        monthlyABCDTotal = 66666;
                        annualABCDTotal = 800000;
                        break;

                    case salaryDetails?.annualCtc==='8.5 CTC' ||salaryDetails?.annualCtc=== '8.5 ctc' || salaryDetails?.annualCtc==='8.5 Ctc':
                        monthlyBasic = 15500;
                        annualBasic = 186000;
                        monthlyHra = 7500;
                        annualHra = 90000;
                        monthlyTotalA = 23000;
                        annualTotalA = 276000;
                        monthlyMedicalAllowance = 1250;
                        annualMedicalAllowance = 15000;
                        monthlyLta = 1600;
                        annualLta = 19200;
                        monthlyConveyance = 1600;
                        annualConveyance = 19200;
                        monthlySpecialAllowance = 33250;
                        annualSpecialAllowance = 399000;
                        monthlyTotalB = 37700;
                        annualTotalB = 452400;
                        monthlyPf = 1800;
                        annualPf = 21600;
                        monthlyTotalC = 1800;
                        annualTotalC = 21600;
                        monthlyABCTotal = 62500;
                        annualABCTotal =  750000;
                        monthlyBenefits = 8333;
                        annualBenefits = 100000;
                        TotalTemp7 = 8333;
                        TotalTemp8 = 100000;
                        monthlyABCDTotal = 70833;
                        annualABCDTotal = 850000;
                        break;

                    case salaryDetails?.annualCtc==='9 CTC' || salaryDetails?.annualCtc==='9 ctc' ||salaryDetails?.annualCtc=== '9 Ctc':
                        monthlyBasic = 15500;
                        annualBasic = 186000;
                        monthlyHra = 6000;
                        annualHra = 72000;
                        monthlyTotalA = 21500;
                        annualTotalA = 258000;
                        monthlyMedicalAllowance = 1250;
                        annualMedicalAllowance = 15000;
                        monthlyLta = 1300;
                        annualLta = 15600;
                        monthlyConveyance = 1600;
                        annualConveyance = 19200;
                        monthlySpecialAllowance = 39217;
                        annualSpecialAllowance = 470600;
                        monthlyTotalB = 43367;
                        annualTotalB = 520400;
                        monthlyPf = 1800;
                        annualPf = 21600;
                        monthlyTotalC = 1800;
                        annualTotalC = 21600;
                        monthlyABCTotal = 66667;
                        annualABCTotal =  800000;
                        monthlyBenefits = 8333;
                        annualBenefits = 100000;
                        TotalTemp7 = 8333;
                        TotalTemp8 = 100000;
                        monthlyABCDTotal = 75000;
                        annualABCDTotal = 900000;
                        break;
                        
                        
                        case salaryDetails?.annualCtc==='9.5 CTC' || salaryDetails?.annualCtc==='9.5 ctc' ||salaryDetails?.annualCtc=== '9.5 Ctc':
                            monthlyBasic = 15500;
                            annualBasic = 186000;
                            monthlyHra = 6000;
                            annualHra = 72000;
                            monthlyTotalA = 21500;
                            annualTotalA = 258000;
                            monthlyMedicalAllowance = 1250;
                            annualMedicalAllowance = 15000;
                            monthlyLta = 1300;
                            annualLta = 15600;
                            monthlyConveyance = 1600;
                            annualConveyance = 19200;
                            monthlySpecialAllowance = 43383;
                            annualSpecialAllowance = 520600;
                            monthlyTotalB = 47533;
                            annualTotalB = 570400;
                            monthlyPf = 1800;
                            annualPf = 21600;
                            monthlyTotalC = 1800;
                            annualTotalC = 21600;
                            monthlyABCTotal = 70833;
                            annualABCTotal =  850000;
                            monthlyBenefits = 8333;
                            annualBenefits = 100000;
                            TotalTemp7 = 8333;
                            TotalTemp8 = 100000;
                            monthlyABCDTotal = 79166;
                            annualABCDTotal = 950000;
                            break;

                            case salaryDetails?.annualCtc==='10 CTC' || salaryDetails?.annualCtc==='10 ctc' || salaryDetails?.annualCtc==='10 Ctc':
                                monthlyBasic = 15500;
                                annualBasic = 186000;
                                monthlyHra = 7500;
                                annualHra = 90000;
                                monthlyTotalA = 23000;
                                annualTotalA = 276000;
                                monthlyMedicalAllowance = 1250;
                                annualMedicalAllowance = 15000;
                                monthlyLta = 1600;
                                annualLta = 19200;
                                monthlyConveyance = 1600;
                                annualConveyance = 19200;
                                monthlySpecialAllowance = 45750;
                                annualSpecialAllowance = 549000;
                                monthlyTotalB = 50200;
                                annualTotalB = 602400;
                                monthlyPf = 1800;
                                annualPf = 21600;
                                monthlyTotalC = 1800;
                                annualTotalC = 21600;
                                monthlyABCTotal = 75000;
                                annualABCTotal =  900000;
                                monthlyBenefits = 8333;
                                annualBenefits = 100000;
                                TotalTemp7 = 8333;
                                TotalTemp8 = 100000;
                                monthlyABCDTotal = 83333;
                                annualABCDTotal = 1000000;
                                break;

            case salaryDetails?.annualCtc==='11 CTC' || salaryDetails?.annualCtc==='11 ctc' ||salaryDetails?.annualCtc=== '11 Ctc':
                monthlyBasic = 17500;
                annualBasic = 210000;
                monthlyHra = 8000;
                annualHra = 96000;
                monthlyTotalA = 25500;
                annualTotalA = 306000;
                monthlyMedicalAllowance = 1250;
                annualMedicalAllowance = 15000;
                monthlyLta = 1600;
                annualLta = 19200;
                monthlyConveyance = 1600;
                annualConveyance = 19200;
                monthlySpecialAllowance = 51580;
                annualSpecialAllowance = 619000;
                monthlyTotalB = 56033;
                annualTotalB = 672400;
                monthlyPf = 1800;
                annualPf = 21600;
                monthlyTotalC = 1800;
                annualTotalC = 21600;
                monthlyABCTotal = 83333;
                annualABCTotal =  1000000;
                monthlyBenefits = 8333;
                annualBenefits = 100000;
                TotalTemp7 = 8333;
                TotalTemp8 = 100000;
                monthlyABCDTotal = 91666;
                annualABCDTotal = 1100000;
                break;


                case salaryDetails?.annualCtc==='11.5 CTC' ||salaryDetails?.annualCtc=== '11.5 ctc' || salaryDetails?.annualCtc==='11.5 Ctc':
                    monthlyBasic = 17500;
                    annualBasic = 210000;
                    monthlyHra = 8000;
                    annualHra = 96000;
                    monthlyTotalA = 25500;
                    annualTotalA = 306000;
                    monthlyMedicalAllowance = 1250;
                    annualSpecialAllowance = 15000;
                    monthlyLta = 1600;
                    annualLta = 19200;
                    monthlyConveyance = 1600;
                    annualConveyance = 19200;
                    monthlySpecialAllowance = 55750;
                    annualSpecialAllowance = 669000;
                    monthlyTotalB = 60200;
                    annualTotalB = 722400;
                    monthlyPf = 1800;
                    annualPf = 21600;
                    monthlyTotalC = 1800;
                    annualTotalC = 21600;
                    monthlyABCTotal = 87500;
                    annualABCTotal= 1050000;
                    monthlyBenefits = 8333;
                    annualBenefits = 100000;
                    TotalTemp7 = 8333;
                    TotalTemp8 = 100000;
                    monthlyABCDTotal = 95833;
                    annualABCDTotal = 1150000;
                    break;        
            
                case salaryDetails?.annualCtc==='12 CTC' ||salaryDetails?.annualCtc=== '12 ctc' || salaryDetails?.annualCtc==='12 Ctc':
                    monthlyBasic = 17500;
                    annualBasic = 210000;
                    monthlyHra = 8000;
                    annualHra = 96000;
                    monthlyTotalA = 25500;
                    annualTotalA = 306000;
                    monthlyMedicalAllowance = 1250;
                    annualMedicalAllowance = 15000;
                    monthlyLta = 1600;
                    annualLta = 19200;
                    monthlyConveyance = 1600;
                    annualConveyance = 19200;
                    monthlySpecialAllowance = 59917;
                    annualSpecialAllowance = 719000;
                    monthlyTotalB = 64367;
                    annualTotalB = 772400;
                    monthlyPf = 1800;
                    annualPf = 21600;
                    monthlyTotalC = 1800;
                    annualTotalC = 21600;
                    monthlyABCTotal = 91667;
                    annualABCTotal =  1100000;
                    monthlyBenefits = 8333;
                    annualBenefits = 100000;
                    TotalTemp7 = 8333;
                    TotalTemp8 = 100000;
                    monthlyABCDTotal = 100000;
                    annualABCDTotal = 1200000;
                    break;
            case salaryDetails?.annualCtc==='13 CTC' || salaryDetails?.annualCtc==='13 ctc' ||salaryDetails?.annualCtc=== '13 Ctc':
                monthlyBasic = 17500;
                annualBasic = 210000;
                monthlyHra = 8000;
                annualHra = 96000;
                monthlyTotalA = 25500;
                annualTotalA = 306000;
                monthlyMedicalAllowance = 1250;
                annualMedicalAllowance = 15000;
                monthlyLta = 1600;
                annualLta = 19200;
                monthlyConveyance = 1600;
                annualConveyance = 19200;
                monthlySpecialAllowance = 68250;
                annualSpecialAllowance = 819000;
                monthlyTotalB = 72700;
                annualTotalB = 872400;
                monthlyPf = 1800;
                annualPf = 21600;
                monthlyTotalC = 1800;
                annualTotalC = 21600;
                monthlyABCTotal = 100000;
                annualABCTotal =  1200000;
                monthlyBenefits = 8333;
                annualBenefits = 100000;
                TotalTemp7 = 8333;
                TotalTemp8 = 100000;
                monthlyABCDTotal = 108333;
                annualABCDTotal = 1300000;
                break;
                

                case salaryDetails?.annualCtc==='16 CTC' || salaryDetails?.annualCtc==='16 ctc' || salaryDetails?.annualCtc==='16 Ctc':
                    monthlyBasic = 30000;
                    annualBasic = 360000;
                    monthlyHra = 15000;
                    annualHra = 180000;
                    monthlyTotalA = 45000;
                    annualTotalA = 540000;
                    monthlyMedicalAllowance = 1250;
                    annualMedicalAllowance = 15000;
                    monthlyLta = 1600;
                    annualLta = 19200;
                    monthlyConveyance = 1600;
                    annualConveyance = 19200;
                    monthlySpecialAllowance = 73750;
                    annualSpecialAllowance = 885004;
                    monthlyTotalB = 78200;
                    annualTotalB = 938400;
                    monthlyPf = 1800;
                    annualPf = 21600;
                    monthlyTotalC = 1800;
                    annualTotalC = 21600;
                    monthlyABCTotal = 125000;
                    annualABCTotal =  1500000;
                    monthlyBenefits = 8333;
                    annualBenefits = 100000;
                    TotalTemp7 = 8333;
                    TotalTemp8 = 100000;
                    monthlyABCDTotal = 133333;
                    annualABCDTotal = 1600000;
                    break;
            case salaryDetails?.annualCtc==='19 CTC' || salaryDetails?.annualCtc==='19 ctc' || salaryDetails?.annualCtc==='19 Ctc':
                monthlyBasic = 30000;
                annualBasic = 360000;
                monthlyHra = 15000;
                annualHra = 180000;
                monthlyTotalA = 45000;
                annualTotalA = 540000;
                monthlyMedicalAllowance = 1250;
                annualMedicalAllowance = 15000;
                monthlyLta = 1600;
                annualLta = 19200;
                monthlyConveyance = 1600;
                annualConveyance = 19200;
                monthlySpecialAllowance = 98750;
                annualSpecialAllowance = 1185000;
                monthlyTotalB = 103200;
                annualTotalB = 1238400;
                monthlyPf = 1800;
                annualPf = 21600;
                monthlyTotalC = 1800;
                annualTotalC = 21600;
                monthlyABCTotal = 150000;
                annualABCTotal =  1800000;
                monthlyBenefits = 8333;
                annualBenefits = 100000;
                TotalTemp7 = 8333;
                TotalTemp8 = 100000;
                monthlyABCDTotal = 158333;
                annualABCDTotal = 1900000;
                break;

                case salaryDetails?.annualCtc==='23 CTC' ||salaryDetails?.annualCtc=== '23 ctc' ||salaryDetails?.annualCtc=== '23 Ctc':
                    monthlyBasic = 30000;
                    annualBasic = 360000;
                    monthlyHra = 10000;
                    annualHra = 120000;
                    monthlyTotalA = 40000;
                    annualTotalA = 480000;
                    monthlyMedicalAllowance = 1250;
                    annualMedicalAllowance = 15000;
                    monthlyLta = 1600;
                    annualLta = 19200;
                    monthlyConveyance = 1600;
                    annualConveyance = 19200;
                    monthlySpecialAllowance = 137083;
                    annualSpecialAllowance = 1644996;
                    monthlyTotalB = 141533;
                    annualTotalB = 1698396;
                    monthlyPf = 1800;
                    annualPf = 21600;
                    monthlyTotalC = 1800;
                    annualTotalC = 21600;
                    monthlyABCTotal = 183333;
                    annualABCTotal =  2200000;
                    monthlyBenefits = 8333;
                    annualBenefits = 100000;
                    TotalTemp7 = 8333;
                    TotalTemp8 = 100000;
                    monthlyABCDTotal = 191666;
                    annualABCDTotal = 2300000;
                    break;
                case salaryDetails?.annualCtc==='25 CTC' ||salaryDetails?.annualCtc=== '25 ctc' || salaryDetails?.annualCtc==='25 Ctc':
                    monthlyBasic = 30000;
                    annualBasic = 360000;
                    monthlyHra = 10000;
                    annualHra = 120000;
                    monthlyTotalA = 40000;
                    annualTotalA = 480000;
                    monthlyMedicalAllowance = 1250;
                    annualMedicalAllowance = 15000;
                    monthlyLta = 1600;
                    annualLta = 19200;
                    monthlyConveyance = 1600;
                    annualConveyance = 19200;
                    monthlySpecialAllowance = 153750;
                    annualSpecialAllowance = 1845000;
                    monthlyTotalB = 158200;
                    annualTotalB = 1898400;
                    monthlyPf = 1800;
                    annualPf = 21600;
                    monthlyTotalC = 1800;
                    annualTotalC = 21600;
                    monthlyABCTotal = 200000;
                    annualABCTotal =  2400000;
                    monthlyBenefits = 8333;
                    annualBenefits = 100000;
                    TotalTemp7 = 8333;
                    TotalTemp8 = 100000;
                    monthlyABCDTotal = 208333;
                    annualABCDTotal = 2500000;
                    break;
            default:
                break;
        }
        setOfferLetterDetails({
            firstname: personalDetails?.first_name,

            lastname: personalDetails?.last_name,

            middlename: personalDetails?.middle_name,

            house : personalDetails?.house,

            street: personalDetails?.street,

            city: personalDetails?.city,

            state: personalDetails?.state,

            ctc: salaryDetails?.annualCtc,

            gender: personalDetails?.gender,

            jobTitle,
            monthlyBasic: monthlyBasic,
            annualBasic: annualBasic,
            monthlyHra: monthlyHra,
            annualHra: annualHra,
            monthlyTotalA: monthlyTotalA,
            annualTotalA: annualTotalA,
            monthlyMedicalAllowance: monthlyMedicalAllowance,
            annualMedicalAllowance:annualMedicalAllowance,
            monthlyLta: monthlyLta,
            annualLta: annualLta,
            monthlyConveyance: monthlyConveyance,
            annualConveyance: annualConveyance,
            monthlySpecialAllowance:monthlySpecialAllowance,
            annualSpecialAllowance:annualSpecialAllowance,

            monthlyTotalB: monthlyTotalB,
            annualTotalB: annualTotalB,
            monthlyPf: monthlyPf,
            annualPf: annualPf,
            monthlyTotalC: monthlyTotalC,
            annualTotalC: annualTotalC,
            monthlyABCTotal: monthlyABCTotal,
            annualABCTotal: annualABCTotal,
            monthlyBenefits: monthlyBenefits,
            annualBenefits: annualBenefits,
            TotalTemp7: TotalTemp7,
            TotalTemp8: TotalTemp8,
            monthlyABCDTotal: monthlyABCDTotal,
            annualABCDTotal: annualABCDTotal,
            Signingdate: offerValid,
            SalaryinWords: val,
            Month: `${Month},${year}`,
        });
    }, [salaryDetails, personalDetails, jobTitle, offerValid]);

    const getOfferLetterTemplates = async () => {
        const response = await getOfferLetterTemplate();
        setOfferTemplates(response.data.data);
    };

    const submit = async (value) => {
        let offerletterurl;
        let yPosition = 0;
        const fontSize = 1;
        const xPosition = 0;
        const widthChart = 480;
        const heightChart = 600;
        let childnodes = document.getElementById('page-container').childNodes;
        let imagesChildrens = [];
        const pdf = new jsPDF({
            orientation: 'portrait',
            compressPdf: true,
            unit: 'px',
            scale: 1,
        });
        childnodes.forEach((child) => {
            imagesChildrens.push(html2canvas(child));
        });

        Promise.all(imagesChildrens).then(async (childs) => {
            pdf.setFontSize(fontSize);
            let arr = [];
            childs.forEach((canvas, index) => {
                const imgData = canvas.toDataURL('image/png');
                arr.push(imgData);

                pdf.addImage(imgData, 'png', xPosition, yPosition, widthChart, heightChart, `canvas-${index}`, 'FAST');
                pdf.addPage();
            });

            // pdf.save(`sample.pdf`);

            let file = pdf.output('datauristring');

            const filename = `${candidate_id}-OfferLetter`;
            let arr1 = file.split(','),
                mime = arr1[0].match(/:(.*?);/)[1],
                bstr = atob(arr1[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }

            var file1 = new File([u8arr], filename, { type: mime });
            let dirName = `Offer-letter`;
            // const pdfBuffer = Buffer.from(new Uint8Array(file));

            let fileData = await uploadBackend(file1, filename, dirName);
            offerletterurl = fileData;

            let offerval = {
                offerletter_status: value,
                candidate_id: candidate_id,
                offerletter_url: offerletterurl,
            };

            if (experience == 'Fresher') {
                updateOfferDetails(offerval).then((res) => {
                    if (res.data.statusCode == 200) {
                    }
                });
            } else {
                updateExpOfferDetails(offerval).then((res) => {
                    if (res.data.statusCode == 200) {
                    }
                });
            }
            setisloading(true);

            if (value == 'Offer Sent') {
                let reason = 'Offer sent to the candidate';
                let payload = {
                    icon_category: 'Initiated',
                    candidateType: experience,
                    audit_reason: reason,
                    candidate_id: candidate_id,
                    job_id: jid,
                };

                let response1 = await postTimeline(payload);
                let content = {
                    Subject: `Avasoft-Offer letter`,
                    body: `<html lang="en">
    
                    <head>
                      <meta charset='utf-8'>
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Invite User</title>
                    </head>
                    
                    <body>
                      <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                       <div style="background-color:#ffffff; width: 100%;">
                        <div style="padding: 15px 32px; background-color: #ffffff;">
                         <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                        </div>
                       </div>
                    
                       <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                       <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                        <h3 style=" font-size: 20px; color: #F29B10;">
                        Hi ${personalDetails?.first_name},
                        </h3>
                        <h3>Congratulations!</h3><br/>
                        <p style=" font-size: 16px; color: #0f0f0f;">
                        With reference to and subsequent interview you had with us; we are pleased to make you an offer for a career with our company. Please find attached the Offer letter from AVASOFTWARE Pvt. Ltd.,
            
                  Kindly follow the link <a href="https://hivecandidate.avasoft.com?id=${jid}">https://hivecandidate.avasoft.com?id=${jid}</a> to find the offer letter, share the acceptance on or before ${offerValid} failing which the offer is invalid<br/><br/>
                  
                  Looking forward to having you on board!
                      </p>
                      <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                       Yours Truly,
                       </p>
                      <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                       Team Avasoft
                       </p>
                       </div>
                      </div>
                      
                    </div>
                    </body>
                    </html>`,
                    to: [personalDetails?.email_id],
                };
                // let content = emailContents.PanelMemberEmail;
                // let body = content.body;
                // body.replace('PanelMemberName', 'Ram Vashakan');
                // content = { ...content, body,  };

                sendMail(content);

                navigate('/Onboarding');
            } else if (value == 'Offer Drafted') {
                let reason = 'Offer Drafted for the candidate';
                let payload = {
                    icon_category: 'Initiated',
                    candidateType: experience,
                    audit_reason: reason,
                    candidate_id: candidate_id,
                    job_id: jid,
                };

                let response1 = await postTimeline(payload);
                navigate('/Onboarding');
            }
        });
    };

    return (
        <div className="tab-pane fade " id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
            <div className="list-bg " style={{ height: '84vh', position: 'relative' }}>
                <div className="border-rad  bg-white p-3 d-flex justify-content-between align-items-center">
                    <p className="font-14 regular-text mb-0">Offer Letter Preview</p>
                    {/* <div className="d-flex align-items-center list-unstyled">
                        <label className="semibold-text font-14 w-50">Offer Template:</label>
                        <select
                            className="form-select offer-dropdwn-width font-14 semibold-text admin-recruit-selectfont"
                            aria-label="Default select example"
                            onChange={(e) => {
                                setSelectedTemplate(e.target.value);
                            }}
                        >
                            <option value={''}>Select</option>
                            {offerTemplates.map((offerTemplate) => {
                                return <option value={offerTemplate.attachment_url}>{offerTemplate.title}</option>;
                            })}
                        </select>
                    </div> */}
                </div>
                <OfferLetterTemplate offerletterDetails={offerletterDetails} />
                <div
                    style={{ position: 'absolute', top: '90%' }}
                    className="border-rad  bg-white p-3 d-flex justify-content-between align-items-center w-100"
                >
                    <button
                        onClick={() => navigate(`/Recruitment/CandidateView?id=${candidate_id}&exp=${experience}`)}
                        className="font-14 regular-text back-btn"
                    >
                        Back
                    </button>
                    <div className="d-flex align-items-center">
                        <button
                            onClick={() => navigate(`/Recruitment/CandidateView?id=${candidate_id}&exp=${experience}`)}
                            className="btn hive-btn-secondary"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={() => {
                                submit('Offer Drafted');
                                setisloading(false);
                            }}
                            className="btn hive-btn-outline me-3"
                        >
                            Save as Draft
                        </button>
                        <button
                            onClick={() => {
                                submit('Offer Sent');
                                setisloading(false);
                            }}
                            className="btn hive-btn-primary"
                        >
                            <img src="/Images/Vector.svg" alt="Send" className="me-2" />
                            Send to Candidate
                        </button>
                    </div>
                    <Loader isLoading={isloading} />
                </div>
            </div>
        </div>
    );
}

export default GenerateOfferletter;
